export function clamp01(value: number | null | undefined): number | undefined {
    if (value == null || Number.isNaN(value)) return undefined;
    if (value < 0) return 0;
    if (value > 1) return 1;
    return value;
}
